<template>
  <div class="formDialog" v-if="formDialogDisplay">
    <div class="formDialogContent">
      <div class="titleAera">{{title}}</div>
      <div class="formArea">
        <div class="item item-name" v-if="formList.nickname !== undefined">
          <label for="name">姓名</label>
          <input type="text" id="name" v-model="formList.nickname">
        </div>
        <div class="item item-number" v-if="formList.telephone !== undefined">
          <label for="number">手机号码</label>
          <input type="number" id="number" v-model="formList.telephone">
        </div>
        <div class="item item-id" v-if="formList.idcard !== undefined">
          <label for="id">身份证号码</label>
          <input type="text" id="id" v-model="formList.idcard">
        </div>
        <div class="item item-address" v-if="formList.address !== undefined">
          <label for="address">邮寄地址</label>
          <textarea name="" id="address" v-model="formList.address"></textarea>
        </div>
      </div>
      <div class="btnArea">
        <div class="btn-item btn-item-confirm lottery-receive" @click="formConfirm" data-url="?m=front&subm=lottery&action=receivemsg">确定</div>
        <div class="btn-item btn-item-cancel" @click="formCancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormDialog",
  data() {
    return {
      tip: 'formDialog',
      formLabelWidth: '30%',
      formSwitch: true, // 表单提交开关
      formPromptWord: [],
      formData: {}, // 用于提交的数据
      formItem: [] // 要这一项是干嘛的呀
    }
  },
  inject: ['reload'],
  props: ['formDialogDisplay', 'title', 'id', 'formList', 'isReload'],
  created() {
    // 添加预览信息
    if (sessionStorage.getItem('preview')) {
      this.formData.preview = 1
    } else {
      this.formData.preview = 0
    }
  },
  methods: {
    reloadAction() {
      if(this.isReload) {
        // 刷新页面
        setTimeout(() => {
          // window.location.reload()
          this.reload()
        }, 100)
      }
    },
    formDataMark() {
      this.formData.id = this.id
      for(let key in this.formList) {
        this.formData[key] = this.formList[key]
      }
      this.formReq()
    },
    formReq() {
      let vm = this
      this.ajaxPost({
        url: '/activity/api.php?m=front&subm=lottery&action=receivemsg',
        data: vm.formData,
        success: function(data) {
          vm.formSwitch = true
          vm.$toast('提交成功')
          // 关闭表单对话框
          vm.formClose()
          // 刷新页面
          vm.reloadAction()
        },
        error: function(data) {
          vm.formSwitch = true
          vm.$toast(data.msg)
        }
      })
    },
    formConfirm() {
      if(!this.formSwitch) {
        return
      }else{
        this.formSwitch = false
      }

      for(let key in this.formList) {
        // 验证表单是否填写完整
        if(!this.formList[key]) {
          this.formPrompt('请填写完整信息！')
          return
        }
        // 填写完整进行验证
        if(key == 'nickname') {
          if(this.formList[key].length > 20) {
            this.formPrompt('用户名称不得超过20个字符！')
            return
          }
        }else if(key == 'telephone') {
          if(!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.formList[key])) {
            this.formPrompt('请输入有效的手机号码！')
            return
          }
        }else if(key == 'idcard') {
          if(!/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$|^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/.test(this.formList[key])) {
            this.formPrompt('请输入有效的身份证号码！')
            return
          }
        }else if(key == 'address') {
          if(this.formList[key].length > 40) {
            this.formPrompt('邮寄地址不得超过40个字符！')
            return
          }
        }
      }
      // 组长数据，发起请求
      this.formDataMark()
    },
    formPrompt(message) {
      let vm = this
      this.$message({
        type: 'error',
        center: true,
        message: message,
        onClose: function() {
          // 重置form表单项
          vm.formItem.length = 0
          vm.formSwitch = true
        }
      })
    },
    formCancel() {
      this.reloadAction()
      this.formClose()
    },
    formClose() {
      this.$emit('update:formDialogDisplay', false)
    }
  }
}
</script>

<style lang="stylus">
.formDialog
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0, 0, 0, 0.5)
  z-index: 999
  .formDialogContent
    margin: 30vw auto 0
    padding: 1em 0 1em
    width: 90vw
    min-height: 30vw
    border-radius: 4px
    background-color: #fff
    .btnArea
      margin-top: 3em
      height: 2em
      display: flex
      justify-content: space-around
      .btn-item
        height: 100%
        line-height: 2em
        width: 5em
        border: 1px solid #000
        border-radius: 6px
      .btn-item-confirm
        background-color: #fde338
        color: #e21843
        border-color: #fde338
    .titleAera
      margin: auto
      margin-bottom: 1em
      width: 80%
      min-height: 2em
      text-align: left
    .formArea
      margin: auto
      width: 90%
      min-height: 1em
      .item
        margin-bottom: 1em
        height: 2em
        display: flex
        label
          flex: 1
          margin-right: 1em
          font-size: 12px
          display: flex
          justify-content: flex-end
          align-items: center
        input, textarea
          width: 70%
          font-size: 1em
          text-indent: 0.5em
          appearance: none
          border: 1px solid #a9a9a9
          &:focus
            border-color: #409eff
        textarea
          height: 2em
          padding: 0.5em 0
</style>





// WEBPACK FOOTER //
// src/components/formDialog/formDialog.vue